import { FrmSelectFromObjects } from "components/formFields/FrmSelectFromObjects";

import { i18n } from "services/i18nService";

import { useRelated } from "hooks/useRelated";

export function FrmClass(props) {
  const { value, onValueChange, maxWidth } = props;
  const classes = useRelated("class");

  return (
    <FrmSelectFromObjects
      options={classes}
      fullWidth
      name="class"
      label={i18n("frmLabel.Class")}
      onValueChange={onValueChange}
      value={value}
      maxWidth={maxWidth}
    />
  );
}
